import React from 'react'
import './assets/base.scss'

import Main from './core/templates/Main'
import { HashRouter } from 'react-router-dom'

import * as firebase from 'firebase/app'
import 'firebase/auth'
import config from './config/config'
import withApollo from './withApollo'

const MainApp = withApollo(Main)

// Initialize Firebase
firebase.initializeApp(config.firebaseConfig)

const App: React.FC = () => {
  return (
    <HashRouter>
      <MainApp />
    </HashRouter>
  )
}

export default App
